<template>
  <div class="container valign-wrapper full">
    <ul class="collection center users">
      <li class="collection-item" v-for="(u, _) in users" :key="_" v-if="users.length > 0" >
          {{ u.username }}
          <a href="#!" class="secondary-content grey-text" @click="remove(u.id)" v-if="$store.claims.users & 2"><i class="material-icons">delete</i></a>
      </li>
      <li class="collection-item" v-if="users.length == 0 && this.$store.claims.users & 1">
          No users have been added yet!
      </li>
      <li class="collection-item" v-if="$store.claims.users & 2">
          <a href="#" class="btn" @click="showUserCreation()">Add user</a>
      </li>
    </ul>
    <div id="create-user" class="modal">
      <div class="modal-content">
        <h4>Create new user</h4>
        <p>Create a new user to allow them to access the Helen management console.</p>
        <form class="form">
          <div class="row">
            <div class="input-field col s12">
              <input id="username" type="text" v-model="username">
              <label for="username">Username</label>
            </div>
            <div class="input-field col s12">
              <input id="password" type="password" v-model="password">
              <label for="password">Password</label>
            </div>
            <div class="input-field col s12">
              <input id="passwordConfirm" type="password" v-model="passwordConfirm">
              <label for="passwordConfirm">Confirm password</label>
            </div>
            <b>Permissions</b>
            <ul class="collection">
                <li class="collection-item">
                    Languages
                    <div class="switch right" :disabled="permissions.admin || permissions.addDevices" v-if="permissions.languages.read">
                        <label>
                        Only read    
                        <input type="checkbox" :disabled="permissions.admin || permissions.addDevices" v-model="permissions.languages.write" v-on:change="updateRequirements()">
                        <span class="lever"></span>
                        Read & Write
                        </label>
                    </div>
                </li>
                <li class="collection-item">
                    <label>
                        <input type="checkbox" :disabled="permissions.admin || permissions.addDevices" class="filled-in" v-model="permissions.phrases.read" v-on:change="updateRequirements()" />
                        <span>Phrases</span>
                    </label>
                    <div class="switch right" v-if="permissions.phrases.read">
                        <label>
                        Only read
                        <input type="checkbox" :disabled="permissions.addDevices" v-model="permissions.phrases.write" v-on:change="updateRequirements()">
                        <span class="lever"></span>
                        Read & write
                        </label>
                    </div>
                </li>
                <li class="collection-item">
                    <label>
                        <input type="checkbox" :disabled="permissions.admin || permissions.addDevices" class="filled-in" v-model="permissions.dialogs.read" v-on:change="updateRequirements()" />
                        <span>Dialogs</span>
                    </label>
                    <div class="switch right" v-if="permissions.dialogs.read">
                        <label>
                        Only read    
                        <input type="checkbox" :disabled="permissions.admin || permissions.addDevices" v-model="permissions.dialogs.write" v-on:change="updateRequirements()">
                        <span class="lever"></span>
                        Read & Write
                        </label>
                    </div>
                </li>
                <li class="collection-item">
                    <label>
                        <input type="checkbox" :disabled="permissions.admin || permissions.addDevices" class="filled-in" v-model="permissions.logs.read" v-on:change="updateRequirements()" />
                        <span>Logs</span>
                    </label>
                    <div class="switch right" v-if="permissions.logs.read">
                        <label>
                        Only read
                        <input type="checkbox" :disabled="permissions.admin || permissions.addDevices" v-model="permissions.logs.write" v-on:change="updateRequirements()">
                        <span class="lever"></span>
                        Read & write
                        </label>
                    </div>
                </li>
                <li class="collection-item">
                    <label>
                        <input type="checkbox" :disabled="permissions.admin || permissions.addDevices" class="filled-in" v-model="permissions.receptionist.read" v-on:change="updateRequirements()" />
                        <span>Receptionist</span>
                    </label>
                    <div class="switch right" v-if="permissions.receptionist.read">
                        <label>
                        Only read
                        <input type="checkbox" :disabled="permissions.admin || permissions.addDevices" v-model="permissions.receptionist.write" v-on:change="updateRequirements()">
                        <span class="lever"></span>
                        Read & write
                        </label>
                    </div>
                </li>
                <li class="collection-item">
                    <label>
                        <input type="checkbox" :disabled="permissions.admin || permissions.addDevices" class="filled-in" v-model="permissions.registertablet.read" v-on:change="updateRequirements()" />
                        <span>Register Tablet</span>
                    </label>
                    <div class="switch right" v-if="permissions.registertablet.read">
                        <label>
                        Only read
                        <input type="checkbox" :disabled="permissions.admin || permissions.addDevices" v-model="permissions.registertablet.write" v-on:change="updateRequirements()">
                        <span class="lever"></span>
                        Read & write
                        </label>
                    </div>
                </li>
                <li class="collection-item">
                    <label>
                        <input type="checkbox" :disabled="permissions.admin || permissions.addDevices" class="filled-in" v-model="permissions.stats.read" v-on:change="updateRequirements()" />
                        <span>Stats</span>
                    </label>
                    <div class="switch right" v-if="permissions.stats.read">
                        <label>
                        Only read
                        <input type="checkbox" :disabled="permissions.admin || permissions.addDevices" v-model="permissions.stats.write" v-on:change="updateRequirements()">
                        <span class="lever"></span>
                        Read & write
                        </label>
                    </div>
                </li>
                <li class="collection-item">
                    <label>
                        <input type="checkbox" :disabled="permissions.admin || permissions.addDevices" class="filled-in" v-model="permissions.userrecord.read" v-on:change="updateRequirements()" />
                        <span>User Record</span>
                    </label>
                    <div class="switch right" v-if="permissions.userrecord.read">
                        <label>
                        Only read
                        <input type="checkbox" :disabled="permissions.admin || permissions.addDevices" v-model="permissions.stats.write" v-on:change="updateRequirements()">
                        <span class="lever"></span>
                        Read & write
                        </label>
                    </div>
                </li>
                <li class="collection-item">
                    <label>
                        <input type="checkbox" class="filled-in" :disabled="permissions.admin || permissions.addDevices" v-model="permissions.settings.read" v-on:change="updateRequirements()" />
                        <span>Settings</span>
                    </label>
                    <div class="switch right" v-if="permissions.settings.read">
                        <label>
                        Only read    
                        <input type="checkbox" :disabled="permissions.admin || permissions.addDevices" v-model="permissions.settings.write" v-on:change="updateRequirements()">
                        <span class="lever"></span>
                        Read & Write
                        </label>
                    </div>
                </li>
                <li class="collection-item">
                    <label>
                        <input type="checkbox" :disabled="permissions.admin || permissions.addDevices" class="filled-in" v-model="permissions.users.read" v-on:change="updateRequirements()" />
                        <span>Users</span>
                    </label>
                    <div class="switch right" v-if="permissions.users.read">
                        <label>
                        Only read    
                        <input type="checkbox" :disabled="permissions.admin || permissions.addDevices" v-model="permissions.users.write" v-on:change="updateRequirements()">
                        <span class="lever"></span>
                        Read & Write
                        </label>
                    </div>
                </li>
                <!--li class="collection-item">
                    <label>
                        <input type="checkbox" :disabled="permissions.admin" class="filled-in" v-model="permissions.links.read" v-on:change="updateRequirements()" />
                        <span>Links</span>
                    </label>
                    <div class="switch right" v-if="permissions.links.read">
                        <label>
                        Only read    
                        <input type="checkbox" :disabled="permissions.admin" v-model="permissions.links.write" v-on:change="updateRequirements()">
                        <span class="lever"></span>
                        Read & Write
                        </label>
                    </div>
                </li-->
                <li class="collection-item">
                    <label>
                        <input type="checkbox" class="filled-in" v-model="permissions.addDevices" v-on:change="updateRequirements()" />
                        <span>Add new devices</span>
                    </label>
                </li>
                <li class="collection-item">
                    <label>
                        <input type="checkbox" class="filled-in" v-model="permissions.admin" v-on:change="updateRequirements()" />
                        <span>Add new Admin</span>
                    </label>
                </li>
            </ul>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-action modal-close waves-effect waves-green btn-flat">Close</a>
        <a href="#!" class="modal-action waves-effect waves-green btn-flat" @click="addUser()">Add user</a>
      </div>
    </div>
  </div>
</template>
<style scoped>
.full{
    height: 100vh;
}
.center{
    margin:auto;
}
.users{
    min-width: 300px;
}
#create-user{
    max-width: 600px;
    top: 3% !important;
}
.modal{
    top: 2%;
    max-height: 98%;
}
</style>
<script>
  export default {
    name: 'users',
    data() {
      return {
        users: [],
        username: "",
        password: "",
        passwordConfirm: "",
        permissions: {
            phrases: {
                read: false,
                write: false
            },
            dialogs: {
                read: false,
                write: false
            },
            languages: {
                read: true,
                write: false
            },
            users: {
                read: false,
                write: false
            },
            settings: {
                read: false,
                write: false
            },
            logs: {
                read: false,
                write: false
            },
            receptionist: {
                read: false,
                write: false
            },
            registertablet: {
                read: false,
                write: false
            },
            stats: {
                read: false,
                write: false
            },
            userrecord: {
                read: false,
                write: false
            },
            /*links: {
                read: false,
                write: false
            },*/
            admin: false,
            addDevices: false,
        }
      }
    },
    methods: {
        update(){
            this.$http
            .get("/auth/users")
            .then(r => {
                this.users = r.data.filter(x => x.username !== "admin")
                this.$store.users = r.data
            })
            .catch(r => {
                M.toast({html: r.data})
            }); 
        },
        getFlag(claim) {
            return (claim.read ? 1 : 0) + (claim.write ? 2 : 0)
        },
        updateRequirements() {
            if(this.permissions.dialogs.write){
                this.permissions.phrases.read = true;
            }
            if(this.permissions.addDevices){
                this.permissions.dialogs.read = true;
                this.permissions.dialogs.write = false;

                this.permissions.phrases.read = true;
                this.permissions.phrases.write = false;

                this.permissions.languages.read = true;
                this.permissions.languages.write = false;

                this.permissions.logs.read = true;
                this.permissions.logs.write = false;

                this.permissions.receptionist.read = true;
                this.permissions.receptionist.write = false;

                this.permissions.stats.read = true;
                this.permissions.stats.write = true;

                this.permissions.registertablet.read = true;
                this.permissions.registertablet.write = true;

                this.permissions.userrecord.read = true;
                this.permissions.userrecord.write = true;

                this.permissions.users.read = false;
                this.permissions.users.write = false;

                this.permissions.settings.read = false;
                this.permissions.settings.write = false;

            }
            if(!this.permissions.dialogs.read){
                this.permissions.dialogs.write = false;
            }
            if(!this.permissions.users.read){
                this.permissions.users.write = false;
            }
            if(!this.permissions.phrases.read){
                this.permissions.phrases.write = false;
            }
            /*if(!this.permissions.links.read) {
                this.permissions.links.write = false;
            }*/
            if(this.permissions.admin){
                this.permissions.addDevices = false;

                this.permissions.phrases.read = true;
                this.permissions.phrases.write = true;
                this.permissions.languages.read = true;
                this.permissions.languages.write = true;
                this.permissions.dialogs.read = true;
                this.permissions.dialogs.write = true;
                this.permissions.settings.read = true;
                this.permissions.settings.write = true;

                this.permissions.logs.read = true;
                this.permissions.logs.write = true;

                this.permissions.receptionist.read = true;
                this.permissions.receptionist.write = true;

                this.permissions.stats.read = true;
                this.permissions.stats.write = true;

                this.permissions.userrecord.read = true;
                this.permissions.userrecord.write = true;

                this.permissions.registertablet.read = true;
                this.permissions.registertablet.write = true;

                this.permissions.users.read = true;
                this.permissions.users.write = true;

                //this.permissions.links.read = true;
                //this.permissions.links.write = true;
            }
        },
        addUser(){
            if(this.password !== this.passwordConfirm){
                M.toast({html: "Passwords does not match"})
                return
            }
            const GRANT = 4;
            const WRITE_GRANT = 6;
            const READ_WRITE_GRANT = 7;
            this.$http
            .post("/auth/users", {username: this.username, password: this.password, claims: { 
                "phrases":          this.getFlag(this.permissions.phrases)      + (this.permissions.addDevices == true ? GRANT : 0) + (this.permissions.admin == true ? GRANT : 0) ,
                "dialogs":          this.getFlag(this.permissions.dialogs)      + (this.permissions.addDevices == true ? GRANT : 0) + (this.permissions.admin == true ? GRANT : 0) ,
                "languages":        this.getFlag(this.permissions.languages)    + (this.permissions.addDevices == true ? GRANT : 0) + (this.permissions.admin == true ? GRANT : 0) ,
                "settings":         this.getFlag(this.permissions.settings)     + (this.permissions.addDevices == true ? GRANT : 0) + (this.permissions.admin == true ? GRANT : 0) ,
                "logs":             this.getFlag(this.permissions.logs)         + (this.permissions.addDevices == true ? GRANT : 0) + (this.permissions.admin == true ? GRANT : 0) ,
                "receptionist":     this.getFlag(this.permissions.receptionist) + (this.permissions.addDevices == true ? GRANT : 0) + (this.permissions.admin == true ? GRANT : 0) ,
                "registertablet":   this.getFlag(this.permissions.registertablet) + (this.permissions.addDevices == true ? GRANT : 0) + (this.permissions.admin == true ? GRANT : 0) ,
                //"stats":            this.getFlag(this.permissions.stats) + (this.permissions.addDevices == true ? GRANT : 0) + (this.permissions.admin == true ? GRANT : 0) ,
                "userrecord":       this.getFlag(this.permissions.userrecord)   + (this.permissions.addDevices == true ? GRANT : 0) + (this.permissions.admin == true ? GRANT : 0) ,
                "users":            this.getFlag(this.permissions.users)        + (this.permissions.admin == true ? GRANT : 0),
                "stats":            this.permissions.addDevices == true ? WRITE_GRANT : (0 +  this.permissions.admin == true ? READ_WRITE_GRANT : 0),
                //"links":            this.getFlag(this.permissions.links)        + (this.permissions.admin == true ? GRANT : 0)
            }})
            .then(r => {
                this.update()
                M.Modal.getInstance(this.$el.querySelector("#create-user")).close();
            }).catch(r => {
                M.toast({html: r.data})
            }); 
        },
        remove(id){
            this.$http
            .delete("/auth/users/" + id)
            .then(r => {
                this.update()
                M.toast({html: "User was removed"})
            }).catch(r => {
                M.toast({html: r.data})
            }); 
        },
        showUserCreation(){
            M.Modal.getInstance(this.$el.querySelector("#create-user")).open();
        }
    },
    mounted() {
        this.$el.querySelectorAll(".modal").forEach(e => M.Modal.init(e, {}));
        this.$el.querySelectorAll('select').forEach(x => M.Select.init(x, {}));
    },
    created() {
      this.update()
    }
  }
</script>